// SPDX-License-Identifier: MIT
import { Link, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { programsApi } from '../../api/client'

export default function ProgramDetailPage() {
  const { slug } = useParams<{ slug: string }>()
  const { data: program, isLoading, isError, refetch } = useQuery({
    queryKey: ['program', slug],
    queryFn: () => programsApi.get(slug!).then(response => response.data),
    enabled: !!slug,
  })

  if (isLoading) return <div className="max-w-5xl mx-auto px-4 py-20">Loading programme...</div>
  if (isError) return <div className="max-w-5xl mx-auto px-4 py-20" role="alert">Unable to load this programme. <button className="btn-outline" onClick={() => refetch()}>Retry</button></div>
  if (!program) return <div className="max-w-5xl mx-auto px-4 py-20">Programme not found.</div>

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <Link to="/learn" className="text-brand-blue">Courses and programmes</Link>
      <div className="mt-6 mb-8">
        <span className="badge badge-amber">Coming soon</span>
        <h1 className="text-3xl font-extrabold my-4">{program.title}</h1>
        <p className="text-brand-muted leading-relaxed">{program.description}</p>
        <a className="btn-outline mt-4" href="https://academy.packetfive.com/certificates#diploma">Preview Academy diploma</a>
      </div>
      <h2 className="text-xl font-bold mb-4">{program.courses.length} courses in programme order</h2>
      <ol className="space-y-3">
        {program.courses.map(course => (
          <li key={course.slug} className="card">
            <Link to={`/learn/${course.slug}`} className="flex gap-4 no-underline">
              <span className="font-bold text-brand-blue tabular-nums">{String(course.position).padStart(2, '0')}</span>
              <span className="min-w-0">
                <span className="font-semibold block">{course.title}</span>
                {!course.is_enrollment_open && <span className="text-sm text-brand-muted">Coming soon</span>}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  )
}
